module.exports = __webpack_public_path__ + "static/media/donbosco16.99794fd4.jpg";